import { Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { EventsService } from '../../service/events.service';
import { Event } from '../../model/event';
import { ValidatorUtils } from '../../utils/validator.utils';
import { UserService } from '../../service/user.service';
import { Color } from 'ng2-charts';
import { PreviewStatisticComponent } from 'src/app/modals/preview-statistic/preview-statistic.component';
 
@Component({
  	selector: 'app-statistics-contractor',
  	templateUrl: './statistics-contractor.component.html',
  	styleUrls: ['./statistics-contractor.component.css']
})

export class StatisticsContractorComponent {

	constructor( 
		private router: Router,
		private route: ActivatedRoute,
		private eventsService: EventsService,
		private userService: UserService,
        private modalService: MDBModalService,
	){
		try{
            this.id = this.route.snapshot.paramMap.get('id');
        } catch{
            this.router.navigate(['/home/events'])
        }
	}

	modalRef: MDBModalRef;
	
	id;
	event: Event;
	is_loaded: boolean = false;
    is_admin: boolean = false;
    is_manager: boolean = false;
	
	//graphic
    barChartDataCars;
    barChartDataVans;
    barChartDataBus;
	barChartDataGiveAway;
    biggest = {van: 10, car: 10, bus: 10, giveAway: 10}

	graphicColor: Color[] = [
        {backgroundColor: '#B1B1B1'},
        {backgroundColor: '#252525'},
    ]

	event_used = {
		totalGiveAway: 0,
		totalSale: 0,
		totalTransaction: 0
	}

	ngOnInit() {
		if (localStorage.getItem('token') == null) {
			this.router.navigate(['']);
    }

		if(this.userService.user.user_type == "admin"){
			this.is_admin = true;
			this.getEvent()
	} else {
		this.getEvent()
	}
		
		
	
    }

    getEvent(){
        this.eventsService.getDashBoard(this.id).subscribe( (data: any) => {	 		
			this.event = { ...data, ...data.objToReturn };
			// Cars 
			// Quantity 
			this.event.cars_transaction_partner_count = data.objToReturn.cars?.carAntecipated?.partnerCarTransactionsTickets || 0;
			this.event.cars_transaction_no_partner_count = data.objToReturn.cars?.carAntecipated?.noPartnerCarTransactionsTickets || 0;
			this.event.cars_partner_car_sales_tickets = data.objToReturn.cars?.carsEvent?.partnerCarSalesTickets || 0;
			this.event.cars_no_partner_car_sales_tickets = data.objToReturn.cars?.carsEvent?.noPartnerCarSalesTickets || 0;
			this.event.cars_give_away = data.objToReturn.cars?.carsGiveAway?.amount || 0;

			// Preço unitário parceiro
			this.event.car_partner_price = data.objToReturn.cars?.carAntecipated?.partnerPrice || 0;
			this.event.car_no_partner_price = data.objToReturn.cars?.carAntecipated?.unitaryPrice || 0;
			this.event.car_partner_event_price = data.objToReturn.cars?.carsEvent?.partnerPrice || 0;
			this.event.car_no_partner_event_price = data.objToReturn.cars?.carsEvent?.unitaryPrice || 0;
			
			// Total 
			this.event.car_transaction_partner_value = this.event.cars_transaction_partner_count * this.event.car_partner_price;
			this.event.car_transaction_no_partner_value = this.event.cars_transaction_no_partner_count * this.event.car_no_partner_price;
			this.event.car_transaction_partner_event_value = this.event.cars_partner_car_sales_tickets * this.event.car_partner_event_price;
			this.event.car_transaction_no_partner_event_value = this.event.cars_no_partner_car_sales_tickets * this.event.car_no_partner_event_price;
			
			// Bus 
			// Quantity 
			this.event.bus_transaction_partner_count = data.objToReturn.bus?.busAntecipated?.partnerBusTransactionsTickets || 0;
			this.event.bus_transaction_no_partner_count = data.objToReturn.bus?.busAntecipated?.noPartnerBusTransactionsTickets || 0;
			this.event.bus_partner_bus_sales_tickets = data.objToReturn.bus?.busEvent?.partnerBusSalesTickets || 0;
			this.event.bus_no_partner_bus_sales_tickets = data.objToReturn.bus?.busEvent?.noPartnerBusSalesTickets || 0;
			this.event.bus_give_away = data.objToReturn.bus?.busGiveAway?.amount || 0;

			// Preço unitário parceiro
			this.event.bus_partner_price = data.objToReturn.bus?.busAntecipated?.partnerPrice || 0;
			this.event.bus_no_partner_price = data.objToReturn.bus?.busAntecipated?.unitaryPrice || 0;
			this.event.bus_partner_event_price = data.objToReturn.bus?.busEvent?.partnerPrice || 0;
			this.event.bus_no_partner_event_price = data.objToReturn.bus?.busEvent?.unitaryPrice || 0;
			
			// Total 
			this.event.bus_transaction_partner_value = this.event.bus_transaction_partner_count * this.event.bus_partner_price;
			this.event.bus_transaction_no_partner_value = this.event.bus_transaction_no_partner_count * this.event.bus_no_partner_price;
			this.event.bus_transaction_partner_event_value = this.event.bus_partner_bus_sales_tickets * this.event.bus_partner_event_price;
			this.event.bus_transaction_no_partner_event_value = this.event.bus_no_partner_bus_sales_tickets * this.event.bus_no_partner_event_price;
			

			// Van
			// Quantity 
			this.event.van_transaction_partner_count = data.objToReturn.vans?.vanAntecipated?.partnerVanTransactionsTickets || 0;
			this.event.van_transaction_no_partner_count = data.objToReturn.vans?.vanAntecipated?.noPartnerVanTransactionsTickets || 0;
			this.event.van_partner_van_sales_tickets = data.objToReturn.vans?.vansEvent?.partnerVanSalesTickets || 0;
			this.event.van_no_partner_van_sales_tickets = data.objToReturn.vans?.vansEvent?.noPartnerVanSalesTickets || 0;
			this.event.van_give_away = data.objToReturn.vans?.vansGiveAway?.amount || 0;

			// Preço unitário parceiro
			this.event.van_partner_price = data.objToReturn.vans?.vanAntecipated?.partnerPrice || 0;
			this.event.van_no_partner_price = data.objToReturn.vans?.vanAntecipated?.unitaryPrice || 0;
			this.event.van_partner_event_price = data.objToReturn.vans?.vansEvent?.partnerPrice || 0;
			this.event.van_no_partner_event_price = data.objToReturn.vans?.vansEvent?.unitaryPrice || 0;
			
			// Total 
			this.event.van_transaction_partner_value = this.event.van_transaction_partner_count * this.event.van_partner_price;
			this.event.van_transaction_no_partner_value = this.event.van_transaction_no_partner_count * this.event.van_no_partner_price;
			this.event.van_transaction_partner_event_value = this.event.van_partner_van_sales_tickets * this.event.van_partner_event_price;
			this.event.van_transaction_no_partner_event_value = this.event.van_no_partner_van_sales_tickets * this.event.van_no_partner_event_price;
			

			

			this.setEvent()
        }, error => {
			localStorage.removeItem('token')
			this.router.navigate([''])
		})
	}

	convertMoney(money) {
		let validator = new ValidatorUtils()
		return validator.convertMoney(money)
	}

	setEvent(){
		this.barChartDataCars = [
			{ data: [this.event.carTransactionTicketQuantity + this.event.carSaleTicketQuantity], label: 'Vendidos' },
			{ data: [this.event.parkedCars], label: 'Acessados' },
			{ data: [this.event.carVipTicketQuantity], label: 'Pacote' }
		];

		this.barChartDataVans = [
			{ data: [(this.event.vanTransactionTicketQuantity + this.event.vanSaleTicketQuantity)], label: 'Vendidos' },
			{ data: [this.event.parkedVans], label: 'Acessados' },
			{ data: [this.event.vanVipTicketQuantity], label: 'Pacote' }
		];

		this.barChartDataBus = [
			{ data: [(this.event.busTransactionTicketQuantity + this.event.busSaleTicketQuantity)], label: 'Vendidos' },
			{ data: [this.event.parkedBus], label: 'Acessados' },
			{ data: [this.event.busVipTicketQuantity], label: 'Pacote' }
		];

		this.biggest.car = (this.event.carTransactionTicketQuantity + this.event.carSaleTicketQuantity) * 1.2;	
		this.biggest.van = (this.event.vanTransactionTicketQuantity + this.event.vanSaleTicketQuantity) * 1.2;
		this.biggest.bus = (this.event.busTransactionTicketQuantity + this.event.busSaleTicketQuantity) * 1.2;
		this.biggest.giveAway = (
			this.event.carGiveAwayTicketQuantity + 
			this.event.vanGiveAwayTicketQuantity +
			this.event.busGiveAwayTicketQuantity
		) * 1.2;

		this.is_loaded = true;
	}

	 
 
}
